<template>
  <div>
    <v-data-table
        :style="{color: $mainColor}"
        :headers="headers"
        :items="listCouncils"
        :loading-text="$t('User.loading_orders')"
        :items-per-page="5"
        :footer-props="{
            itemsPerPageOptions: [5, 15,-1],
            itemsPerPageText: 'кол-во на стр.:',
        }"
    >
      <template v-slot:body="{ items, isSelected, select}">
        <tbody>
            <tr v-if="items.length == 0">
                <td colspan="5">
                    <b>Записи о экспертных советах отсутствуют</b>
                </td>
            </tr>
            <tr v-else v-for="item in items" :key="item.id" :class="row_classes(item)" @click="openPopupCard(item.id)" style="cursor: pointer;">
                <td>
                    <span><b>{{ item.name }}</b></span>
                </td>
                <td>
                    <span><b>{{ item.session_name }}</b></span>
                </td>
                <td>
                    <span>
                        <i style="font-style: italic;">{{ item.session_start ? g.toDate(item.session_start) + ' - ' + g.toDate(item.session_end) : '' }}</i>
                    </span>

                </td>
                <td>
                    <span><b>{{ item.proposal_count }}</b></span>
                </td>
                <td>
                    <span><i style="font-style: italic;">{{ g.toDate(item.date) }}</i></span>
                </td>
            </tr>
        </tbody>
      </template>
    </v-data-table>

    <v-row style="max-width: 350px;">
      <v-col class="pt-0">
          <v-card-text class="pt-0 pb-0" style="margin-top: -40px !important;">
            <v-list class="d-flex align-center justify-start">
              <v-list-item>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="red_bg"
                  @click=""
                  v-bind="attrs"
                  v-on="on"
                  style="cursor:help;"
                  x-small>
                    В планировании
                </v-btn>
              </template>
                <span>Пожалуйста, распределите ПРЕДВАРИТЕЛЬНОЕ время выполнения заявок из совета</span>
                </v-tooltip>
              </v-list-item>
              <v-list-item>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="gray_bg"
                      @click=""
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      style="cursor:help;"
                    >
                      На очном рассмотрении
                    </v-btn>
                  </template>
                  <span>На очном рассмотрении экспертным советом. Скоро будет доступен для распределения предварительного времени</span>
                </v-tooltip>
              </v-list-item>
              <v-list-item>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class=""
                      @click=""
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      style="cursor:help;"
                    >
                      Завершен
                    </v-btn>
                  </template>
                  <span>Экспертный совет завершен, решение утверждено</span>
                </v-tooltip>
              </v-list-item>
            </v-list>
          </v-card-text>
      </v-col>
    </v-row>


    <v-dialog v-model="dialogCard"  max-width="90%">
      <modal-card
        :station_id="GETTERS_CURRENT_STATION"
        @closeCouncilDialog="dialogCard=false"
        @updateParent="update_parent($event.item, $event.close_modal)"
      />
    </v-dialog>
      
  </div>
</template>

<script>

import { mapActions, mapMutations, mapGetters } from 'vuex'
import modalCard from './modalCardBs.vue'

export default {

  async beforeMount() {
    this.loadListCouncils()
  },

  components: {
    modalCard
  },

  name: 'CouncilTable',

  data: () => ({
    headers: [
      { text: 'Совет', sortable: true, value: 'name', width: '15%'},
      { text: 'Название сессии', sortable: true, value: 'session_name', width: '20%'},
      { text: 'Период', sortable: true, value: 'session_start', width: '25%'},
      { text: 'Заявок', sortable: true, value: 'proposal_count', width: '20%'},
      { text: 'Дата совета', sortable: true, value: 'date', width: '20%'},
    ],

    dialogCard: false,
    listCouncils: [],
  }),

  computed: {
    ...mapGetters(['GETTERS_CURRENT_STATION'])
  },

  methods:{
    ...mapActions([
      'GET_LIST_COUNCILS',
      'GET_COUNCIL_ALL'
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    row_classes(item) {
      if(item.status == 5)
        return "red_bg"
      else if(item.status == 2)
        return "gray_bg"
      else
        return "";
    },


      async openPopupCard(id) {
        this.UPDATE_OVERLAY(true)
        this.GET_COUNCIL_ALL(id)
        .then(() => {
          this.UPDATE_OVERLAY(false)
          this.dialogCard = true
        })        
      },

      async loadListCouncils() {
        this.listCouncils = [];

        this.GET_LIST_COUNCILS({view_type: 'station', station_id: this.GETTERS_CURRENT_STATION })
          .then((res) => {
            this.listCouncils = res.data;
          })
          .catch((e) => {
          })
      },

      update_parent(item, close_modal = true) {
        if(close_modal)
          this.dialogCard = false;

        this.loadListCouncils();
    },

  },

  watch: {
    GETTERS_CURRENT_STATION(val){
      if(val){
        this.loadListCouncils()
      }
    },
  }
};

</script>

